var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeanTopShine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 57,
    viewBox: "0 0 58 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_462_454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7636 31.4389C22.0712 29.5459 18.6767 28.5946 15.059 29.0655C8.81867 29.8755 3.8292 35.0179 3.12239 41.3471C2.18309 49.8236 8.70707 57.0004 16.8818 57.0004H40.769C47.9905 57.0004 54.2448 51.533 54.8772 44.2479C55.6026 35.9268 49.1483 28.9478 41.0805 28.9478C38.1882 28.9478 35.5052 29.8472 33.2871 31.3824C30.697 33.1719 27.3351 33.252 24.759 31.4437L24.7636 31.4389Z",
    fill: "#1471D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6278 0H28.4513V16.1902H29.6278V0Z",
    fill: "#1471D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.892 0.976607L18.7451 1.24219L22.3087 17.025L23.4556 16.7594L19.892 0.976607Z",
    fill: "#1471D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6241 4.12985L9.56445 4.64746L16.5098 19.2299L17.5695 18.7123L10.6241 4.12985Z",
    fill: "#1471D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.27619 9.28842L1.35352 10.0352L11.3339 22.6828L12.2566 21.9361L2.27619 9.28842Z",
    fill: "#1471D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7284 9.23373L45.7764 21.9043L46.6971 22.646L56.6491 9.97541L55.7284 9.23373Z",
    fill: "#1471D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3668 4.08535L40.4541 18.6837L41.5149 19.1989L48.4276 4.60052L47.3668 4.08535Z",
    fill: "#1471D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0907 0.95805L34.5625 16.749L35.7099 17.012L39.2382 1.22099L38.0907 0.95805Z",
    fill: "#1471D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4551 5.98586L15.3449 6.38004L18.0479 14.1881L19.1581 13.794L16.4551 5.98586Z",
    fill: "#1471D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.36953 9.7909L7.37402 10.4258L11.7277 17.4272L12.7232 16.7923L8.36953 9.7909Z",
    fill: "#1471D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33267 15.3234L0.501953 16.167L6.28714 22.0094L7.11786 21.1658L1.33267 15.3234Z",
    fill: "#1471D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6656 15.2371L50.8966 21.0959L51.7296 21.9371L57.4987 16.0783L56.6656 15.2371Z",
    fill: "#1471D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6108 9.73316L45.2765 16.7469L46.2737 17.379L50.608 10.3652L49.6108 9.73316Z",
    fill: "#1471D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5172 5.95398L38.8357 13.7697L39.947 14.1607L42.6285 6.34501L41.5172 5.95398Z",
    fill: "#1471D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8 4.09983L31.9062 12.3242L33.0803 12.4551L33.974 4.23067L32.8 4.09983Z",
    fill: "#1471D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0565 4.12258L23.8878 4.25952L24.8268 12.4787L25.9955 12.3418L25.0565 4.12258Z",
    fill: "#1471D2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_462_454"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 57,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeanTopShine);
export default __webpack_public_path__ + "static/media/bean-top-shine.3e6863f54f04f5704991b4f7d0595df5.svg";
export { ForwardRef as ReactComponent };